module.exports = __webpack_public_path__ + "img/rw.85f6ca97.svg";